"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncIncludesAnySubseq = asyncIncludesAnySubseq;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _asyncIncludes_ = require("../$includes_/async-includes_");

const config = {
  any: true,
  subseq: true
};

function asyncIncludesAnySubseq(iterable, subseqs) {
  return (0, _asyncIncludes_.asyncIncludes_)(iterable, config, subseqs);
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncIncludesAnySubseq, {
  reduces: true
});

exports.default = _default;